<template>
    <v-row no-gutters>
        <v-col cols="12" sm="12" md="4">
            <label class="f-label f-label-more-rows">{{$t(labelText)}}
                <span v-if="lang=='KZ'">({{$t("каз._яз.")}})</span>
                <span v-if="lang=='RU'">({{$t("рус._яз.")}})</span>
            </label>
        </v-col>
        <v-col cols="12" sm="12" md="8">
            <v-text-field
                @input="handle"
                v-model="content"
                hide-details
                required
                outlined
                dense 
                :rules="rules"               
            >
            </v-text-field>
        </v-col>
    </v-row>
</template>
<script>

export default {
    name: "FieldEditText",
    props: {
        label: {
            type: String,
            default: null
        },
        value: {
            type: String,
            default: null
        },
        rules: null
    },
    data() {
        return {
            content: this.value
        }
    },
    computed: {
        labelText() {
            try {
                const labelObj =JSON.parse(this.label);
                if (labelObj?.label)
                    return labelObj.label;
            }
            catch(ex) {
                return this.label;
            }
            return this.label;
        },
        lang() {
            try {
                const labelObj =JSON.parse(this.label);
                if (labelObj?.lang)
                    return labelObj.lang;
            }
            catch(ex) {
                return null;
            }
            return null;
        }
    },
    methods: {
        handle(e) {
            this.$emit('input', e);
        }
    }
};
</script>

